import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Firestore, collection, query, where, getDocs, docData } from '@angular/fire/firestore';
import { AuthService } from 'src/app/services/auth.service';
import { CommonModule, DecimalPipe } from '@angular/common';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-success',
  standalone: true,
  imports: [CommonModule, DecimalPipe],
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
})
export class SuccessComponent implements OnInit, OnDestroy {
  loading = true;
  error: string | null = null;

  payment$!: Observable<any>;
  private sub?: Subscription;

  constructor(
    private route: ActivatedRoute,
    private firestore: Firestore,
    private auth: AuthService,
    private router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    const user = this.auth.currentUser;

    if (!user) {
      this.router.navigate(['/login']);
      return;
    }

    const stripeCheckoutSessionId =
      this.route.snapshot.queryParamMap.get('session_id');

    if (!stripeCheckoutSessionId) {
      this.error = 'Missing payment reference.';
      this.loading = false;
      return;
    }

    try {
      // Query Firestore for a payment document with this stripeSessionId
      const paymentsCol = collection(this.firestore, `users/${user.uid}/payments`);
      const q = query(paymentsCol, where('stripeSessionId', '==', stripeCheckoutSessionId));
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        this.error = 'Payment not found.';
        this.loading = false;
        return;
      }

      // There should be only one matching document
      const paymentDoc = querySnapshot.docs[0];

      this.payment$ = docData(paymentDoc.ref, { idField: 'id' });

      // Subscribe to live updates
      this.sub = this.payment$.subscribe({
        next: () => (this.loading = false),
        error: () => {
          this.error = 'Unable to load payment.';
          this.loading = false;
        },
      });
    } catch (err) {
      console.error(err);
      this.error = 'Failed to load payment.';
      this.loading = false;
    }
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  goToDashboard(): void {
    this.router.navigate(['/tenant']);
  }
}
